/**
 * Hands a blob to the browser as a download under `name`, through an anchor
 * that is clicked and removed. The object URL is revoked after the click has
 * been handled, or some browsers save nothing. Q3's helper, D34, shared with
 * Consumer reports by D38.
 */
export function saveFile(file: Blob, name: string) {
  const url = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // After the click has been handled, or some browsers save nothing.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
